/**
 * Counterfactual marketplace-fee math for the savings banner.
 *
 * The fee structure is Reverb's for a standard (non-Preferred) seller,
 * verified 2026-09-25 against help.reverb.com ("What fees will I pay for
 * selling on Reverb?" and "What is a payment processing fee?"):
 *   - selling fee: 5% of the sale amount, minimum $0.50, maximum $500
 *   - payment processing: 3.19% + $0.49 per transaction
 *
 * Reverb applies both fees to the sale amount INCLUDING shipping; we compute
 * on the pedal value alone, so the number shown is deliberately conservative
 * and the banner copy says "not including shipping". Re-verify these
 * constants when Reverb announces fee changes. The UI never names Reverb
 * ("the next major marketplace").
 */
export const SELLING_FEE_RATE = 0.05;
export const SELLING_FEE_MIN_CENTS = 50;
export const SELLING_FEE_MAX_CENTS = 50000;
export const PROCESSING_RATE = 0.0319;
export const PROCESSING_FLAT_CENTS = 49;

// Below $5 the comparison against our own $3 flat fee is unimpressive, so
// the banner stays hidden (Jason's call, 2026-09-25).
export const MIN_BANNER_FEE_CENTS = 500;

export function marketplaceFeeCents(valueCents) {
  const v = Math.round(Number(valueCents) || 0);
  if (v <= 0) return 0;
  const selling = Math.min(
    SELLING_FEE_MAX_CENTS,
    Math.max(SELLING_FEE_MIN_CENTS, Math.round(v * SELLING_FEE_RATE))
  );
  const processing = Math.round(v * PROCESSING_RATE) + PROCESSING_FLAT_CENTS;
  return selling + processing;
}

/**
 * Dollars in, whole dollars out (rounded), for display. Returns 0 when the
 * fee is under the display floor, which callers treat as "don't show".
 */
export function marketplaceFeeSavingsDollars(valueDollars) {
  const cents = marketplaceFeeCents(Math.round((Number(valueDollars) || 0) * 100));
  if (cents < MIN_BANNER_FEE_CENTS) return 0;
  return Math.round(cents / 100);
}
